import {Expose, Type} from 'class-transformer';
import {UserApiModel} from './user.api-model';
import {AbstractApiModel} from './abstract.api.model';
import {MediaObjectApiModel} from './media-object.api-model';
import {HashtagApiModel} from "./hashtag.api.model";
import {MetadataApiModel} from "./metadata.api.model";

export class FeedApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public type: string;
  @Expose() public heading: string;
  @Expose() public content: string;
  @Type(() => MediaObjectApiModel)
  @Expose() public cover: (MediaObjectApiModel | string);
  @Expose()
  @Type(() => HashtagApiModel)
  public hashtags: HashtagApiModel[];
  @Expose()
  @Type(() => MediaObjectApiModel)
  public media: (MediaObjectApiModel | string)[];
  @Type(() => UserApiModel)
  @Expose()
  public authors: (UserApiModel | string);
  @Expose() public updatedAt: Date;
  @Expose() public createdAt: Date;
  @Type(() => Date)
  @Expose() public publishedAt: Date;
  @Type(() => MetadataApiModel)
  @Expose() public metadata: MetadataApiModel;
  @Expose() public slug: string;
  @Expose() public visits: number;
  public isPlaceholder: boolean = false;
}
